// Logique d'affichage du personnel : demi-journées en jours, période d'un congé, tons des états, jour
// civil de Libreville, codes d'erreur d'import lisibles.
import type { CongeVueValidation, EtatCongePersonnel } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';
import { date } from '../../commun/format';

export const TON_CONGE: Record<EtatCongePersonnel, TonEtat> = { demande: 'attente', valide_chef: 'signer', valide_rh: 'ok', refuse: 'neutre', annule: 'neutre' };

/** Demi-journées affichées en jours (n / 2), avec une décimale si besoin. */
export function jours(demiJournees: number): string {
  const n = demiJournees / 2;
  return `${n.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} ${Math.abs(n) > 1 ? 'jours' : 'jour'}`;
}

const DEMI = ['matin', 'après-midi'] as const;

export function periode(c: Pick<CongeVueValidation, 'debut' | 'fin' | 'debut_demi_journee' | 'fin_demi_journee'>): string {
  return `du ${date(c.debut)} ${DEMI[c.debut_demi_journee] ?? ''} au ${date(c.fin)} ${DEMI[c.fin_demi_journee] ?? ''}`.replace(/\s+/g, ' ').trim();
}

/** Jour civil de Libreville (UTC + 1). */
export function aujourdhuiIso(maintenant = new Date()): string {
  return new Date(maintenant.getTime() + 3_600_000).toISOString().slice(0, 10);
}

export const LIBELLES_ERREUR_IMPORT: Record<string, string> = {
  matricule_inconnu: 'matricule inconnu dans la collectivité',
  jour_invalide: 'date invalide (attendu AAAA-MM-JJ)',
  etat_invalide: 'état invalide (present, absent, mission ou conge)',
  avant_entree: 'date antérieure à l\'entrée de l\'agent',
  doublon_fichier: 'doublon dans le fichier (même agent et même jour)',
  presence_deja_saisie: 'présence déjà saisie avec un autre état',
};

export const JOURS_SEMAINE = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'] as const;
